import { useState } from 'react';
import { boxStatus } from '../enum/boxStatus';
import BoxAPI from '../services/box.api.service';
import useAlert from './Alert/useAlert';
import { BoxSelector } from './BoxSelector';
import { CountrySelector } from './CountrySelector';
import DateInput from './input/DateInput';
import { SubmitButton } from './SubmitButton';
import Title from './Title';

export const CreateRebox = ({customer}) => {
    const defaultState = {
        box: '',
        country: '',
        expires: null,
        loading: false,
    };

    const {showSuccessAlert, showErrorAlert} = useAlert();
    const [state, setState] = useState({...defaultState});
    const changeState = partialState => setState(currentState => ({...currentState, ...partialState}));

    const handleSubmit = () => {
        changeState({loading: true});
        BoxAPI
            .rebox(state.box.hash, {
                customer: customer.id,
                country: state.country?.code,
                expires: state.expires,
            })
            .then(() => {
                showSuccessAlert('NFT successfully generated');
                changeState({...defaultState});
            })
            .catch(err => showErrorAlert(err.response.data.message))
            .finally(() => changeState({loading: false}));
    }

    return <>
        <Title>NFT re-boxing</Title>
        <BoxSelector
            customer={customer}
            selectedBox={state.box}
            onBoxChange={box => changeState({box})}
            boxStatus={boxStatus.active}
        />
        <CountrySelector
            label="New Country"
            onChange={country => changeState({country})}
        />
        <DateInput
            label="NFT Basic Ingredients Expiring"
            value={state.expires}
            onChange={expires => changeState({expires})}
        />
        <SubmitButton
            text="NFT GENERATION"
            loading={state.loading}
            disabled={
                !customer
                || !state.box
                || !state.country
                || !state.expires
            }
            handleSubmit={handleSubmit}
        />
    </>
}
